import React, { useRef } from "react";
import { gsap, useGSAP, MOTION_OK } from "../../lib/gsap";
import { intro, story } from "../../data/about";
import { Mask } from "./Chrome";

function About() {
  const root = useRef(null);

  // Words brighten one by one as the lead paragraph scrolls through the viewport
  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        gsap.fromTo(
          ".about-lead .word",
          { opacity: 0.18 },
          {
            opacity: 1,
            stagger: 0.1,
            ease: "none",
            scrollTrigger: { trigger: ".about-lead", start: "top 80%", end: "bottom 50%", scrub: true },
          }
        );
      });
      return () => mm.revert();
    },
    { scope: root }
  );

  return (
    <section id="about" className="section" ref={root}>
      <div className="wrap">
        <div className="about-top">
          <div>
            <p className="eyebrow">About me</p>
            <h2 className="section-title">
              <Mask>Your technical</Mask>
              <Mask>co-founder,</Mask>
              <Mask>
                <em>on demand.</em>
              </Mask>
            </h2>
            <p className="about-lead">
              {intro.split(" ").map((w, i) => (
                <span key={i} className="word">
                  {w}{" "}
                </span>
              ))}
            </p>
          </div>
          {/* Desktop only: the avatar glides here from the hero as you scroll */}
          <div className="avatar-slot avatar-slot--about" data-avatar-slot="about" aria-hidden="true" />
        </div>
        <div className="about-cols">
          {story.map((p, i) => (
            <p key={i} data-reveal data-index={`0${i + 1}`}>
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
